import { useI18n } from 'next-localization';

import { isEmpty } from 'lodash-es';

import { useListingContext } from '../hooks';

export const SearchTips = (): JSX.Element => {
  const { t } = useI18n();

  const { showAcceptingNewPatientsOnly, selectedGenders, searchValue, zip } = useListingContext();
  const showTips =
    !isEmpty(zip) ||
    !isEmpty(searchValue) ||
    !isEmpty(selectedGenders) ||
    showAcceptingNewPatientsOnly;

  if (!showTips) {
    return <></>;
  }

  /* Display tip message for: location, provider, gender, newPatients  */
  // TODO: when AC are final: add tips for - Language, Telemedicine available, and Facility filters
  return (
    <div className="d-flex flex-column align-items-center">
      <h4 className="align-self-start mx-auto mb-3 text-bold" style={{ width: 280 }}>
        {t('OAS.Listing.SearchTips.Title')}:
      </h4>
      <ul>
        {!isEmpty(zip) && <li> {t('OAS.Listing.SearchTips.Location')}</li>}
        {!isEmpty(searchValue) && <li>{t('OAS.Listing.SearchTips.Keyword')}</li>}
        {!isEmpty(selectedGenders) && <li>{t('OAS.Listing.SearchTips.Gender')}</li>}
        {showAcceptingNewPatientsOnly && <li>{t('OAS.Listing.SearchTips.NewPatients')}</li>}
      </ul>
    </div>
  );
};
